/* External */
import {
  memo, useCallback, useState, useEffect, useMemo, useRef,
} from 'react';

/* Components */
import LanderPage from '../../../components/LanderPage';
import LanderTitle from '../../../components/LanderTitle';

/* Providers */
import { useGtmLocalContext } from '../../../providers/GtmLocalProvider';

/* Utils */
import { PageType } from '../../../utils/constants';
import { useOnBackPress } from '../../../utils/keyDownEvents';
import { useOpenSidebar } from '../../../providers/SidebarStateContext';
import { useCountry } from '../../../providers/ConfigProvider';
import {
  GTM_CATEGORIES,
  GTM_EVENT_NAMES,
  GTM_SUBCATEGORIES,
} from '../../../utils/googleTags';
import { convertRemToPixels } from '../../../utils/functions';

/* Styles */
import './MyPage.scss';

// Receives the same padding-top value applied to the lander
const LANDER_PADDING_TOP = convertRemToPixels(8.5);

function MyPage() {
  const { commonTaggingEvent } = useGtmLocalContext();
  const tagsMountRef = useRef(true);
  const country = useCountry();
  const goToSidebar = useOpenSidebar();
  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = useCallback((scrollOffset) => {
    setIsScrolled(scrollOffset > LANDER_PADDING_TOP);
  }, []);

  const landerTitle = useMemo(() => (
    <LanderTitle
      className="dtv-html5-c-my-page__title"
      small={isScrolled}
    />
  ), [isScrolled]);

  const handleBackPress = useCallback(() => {
    goToSidebar();
  }, [goToSidebar]);

  useOnBackPress({ listener: handleBackPress });

  useEffect(() => {
    if (tagsMountRef.current && country) {
      commonTaggingEvent({
        category: GTM_CATEGORIES.MY_PAGE_DATA,
        subCategory: GTM_SUBCATEGORIES.MY_PAGE.LANDER,
        eventName: GTM_EVENT_NAMES.PAGE_VIEW,
      });
      tagsMountRef.current = false;
    }
  }, [commonTaggingEvent, country]);

  return (
    <LanderPage
      className="dtv-html5-c-my-page__lander"
      pageId={PageType.MY_PAGE}
      preContent={landerTitle}
      onScroll={handleScroll}
      withoutFeatured
    />
  );
}

export default memo(MyPage);
